export const SERVICE_ORDER_PDF_COLUMNS = [
  'number',
  'branch',
  'orderType',
  'orderVariant',
  'orderState',
  'vehicle',
  'vehicleLicencePlate',
  'vehicleVin',
  'actualMileage',
  'fuelTank',
  'customerName',
  'createdAt',
  'openedAt',
  'closedAt',
  'totalPriceWithoutVat',
  'totalPriceWithVat',
  'requests',
] as const;
